module.exports = __webpack_public_path__ + "static/20260827_Q2_2026_Announcement_Financial_Results_final-91e30d2e48099c3af7541b807def4e9e.pdf";